<template>
  <!-- <v-container> -->
    <!-- <v-layout wrap>
      <v-flex> -->
      <!-- <div> -->
        <v-row justify="center">
          <v-avatar
            class="back-img"
            :width="this.imgWidth"
            :height="this.imgHeight"
          >
            <v-img
              src="/contact/post.svg"
            ></v-img>
          </v-avatar>
          <div class="scroll">
            <h1 class="scroll-message"><v-icon large color="white">mdi-email</v-icon> Thank you!</h1>
          </div>
        </v-row>
      <!-- </div> -->
      <!-- </v-flex>
    </v-layout> -->
    <!-- <v-row justify="end" clsss="scroll">
      <h1 class="scroll-message">Thank you!</h1>
    </v-row> -->
  <!-- </v-container> -->
</template>
<style scoped>
  .back-img{
    position: absolute;
    z-index: 1;
    margin-top: 20px;
  }
  .scroll{
    position: absolute;
    z-index: 2;
    width: 50%;
    overflow: hidden !important;
    white-space : nowrap;
  }
  .scroll-message{
    color: white;
    text-shadow: 2px 3px 3px #808080;
    display     : inline-block;
    padding-left:   100%;
    display: inline-block;
    animation:  scrollAnime 4s linear;
    margin-top: 180px;
  }
  @keyframes scrollAnime{
      0% { transform: translateX(0)}
    100% { transform: translateX(-100%)}
  }
</style>

<script>
  export default {
    name: 'Thanks',
    props:[
      'imgWidth', 'imgHeight',
    ],
    data: () => ({
      width: 100,
      height: 100  
    })
  }
</script>
